var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.5645 12.629C33.4131 9.67823 29.3234 8.06069 24.9847 8.06452C17.1764 8.07137 10.4355 13.4252 8.57429 20.8518C8.43881 21.3924 7.95716 21.7742 7.3998 21.7742H1.62329C0.86744 21.7742 0.293246 21.088 0.433064 20.3452C2.61421 8.7625 12.7836 0 25 0C31.6984 0 37.7814 2.63468 42.2697 6.92389L45.87 3.32359C47.3941 1.7995 50 2.87893 50 5.03438V18.5484C50 19.8846 48.9168 20.9677 47.5806 20.9677H34.0666C31.9112 20.9677 30.8318 18.3618 32.3558 16.8376L36.5645 12.629ZM2.41935 29.0323H15.9334C18.0888 29.0323 19.1682 31.6382 17.6442 33.1624L13.4355 37.3711C16.5869 40.322 20.6769 41.9395 25.0157 41.9356C32.82 41.9285 39.5636 36.5783 41.4257 29.1484C41.5612 28.6078 42.0428 28.226 42.6002 28.226H48.3768C49.1327 28.226 49.7069 28.9122 49.567 29.655C47.3858 41.2375 37.2164 50 25 50C18.3016 50 12.2186 47.3653 7.73034 43.0761L4.13004 46.6764C2.60595 48.2005 0 47.1211 0 44.9656V31.4516C0 30.1154 1.08317 29.0323 2.41935 29.0323Z",
    fill: "#40A4CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.cbbc00e9238fc9ea8142a6719aff599d.svg";
export { ForwardRef as ReactComponent };